import type { ApplicantScopedKeyArguments } from "./callScriptShared.types";

export type WorknumberKeyArguments = ApplicantScopedKeyArguments;

/**
 * Hierarchical query-key factory for the Work Number (purchased employer info)
 * reads. Mirrors the other feature key factories so cache invalidation stays
 * predictable: invalidating `all` flushes every work-number query, and the
 * per-scope helpers flush a single applicant's eligibility or history. Never
 * write a literal key array outside this module — the factory IS the schema.
 *
 * Keyed on approvalId + applicantId, matching the BFF path
 * `/api/v1/workbench/{approvalId}/applicants/{applicantId}/worknumber/…`.
 */
export const worknumberKeys = {
  all: ["worknumber"] as const,
  eligibility: (arguments_: WorknumberKeyArguments) => [...worknumberKeys.all, "eligibility", arguments_] as const,
  history: (arguments_: WorknumberKeyArguments) => [...worknumberKeys.all, "history", arguments_] as const,
};
